import React from "react";
const ColorField = (props: any) => {
  const { placeholder, value, register, errors, label } = props;
  return (
    <>
      <div className="w-full my-2 text-left mt-4">
        <label htmlFor="">{label}</label>
        <input
          placeholder={placeholder}
          defaultValue={value}
          {...register}
          type={"color"}
          className="w-full focus:outline-none bg-[#EEF5F4] mt-1"
        />
        {errors && (
          <p className="text-red-500 text-xs my-1">{errors?.message}</p>
        )}
      </div>
    </>
  );
};

export default ColorField;
